import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from './auth.service';
import { withAuthRetry } from './auth-refresh';

function isApiRequest(url: string): boolean {
  return url.startsWith('/api/');
}

function isAuthEndpoint(url: string): boolean {
  return url.startsWith('/token/') || url.startsWith('/logout') || url.startsWith('/get_access');
}

export const authRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  if (isAuthEndpoint(req.url)) return next(req);
  if (!isApiRequest(req.url)) return next(req);

  const auth = inject(AuthService);
  const router = inject(Router);

  return withAuthRetry(
    auth,
    () => next(req),
    (err) => err instanceof HttpErrorResponse && err.status === 401,
  ).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        auth.markUnauthenticated();
        void router.navigate(['/']);
      }
      return throwError(() => err);
    }),
  );
};
